/* Copyright (c) Trimble Inc. All rights reserved. */
import React from "react";
import { ProductList } from "../components/ProductList.viewer";
import GenericPageTitle from "modus/components/generic-page-title/GenericPageTitle";
import { Box } from "@material-ui/core";

export const ProductDiscovery:React.FC = () => {
    return (
        <Box m={2}>
            <GenericPageTitle
                title={"Products"}
                description={<>Subscribe to products to begin leveraging API and Event capabilities</>}
                noSkeleton
            />
            <ProductList/>
        </Box>
    )
};

export default ProductDiscovery;
